import axios from '@/axios'

export default {
  fetchData(params){
    return axios.post(`/reports/material`, params)
  },
  export(params){
    return axios.post(`/reports/material/export`, params)
  }
}